import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import { TextField, Checkbox } from "@mui/material";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { savedSearchAdded } from "../slices/savedSearches/savedSearchesSlice";
import { saveSearch } from "../slices/savedSearches/savedSearchAPI";

const SaveSearchModal = ({ openSaveSearchModalState, setOpenSaveSearchModalState, header, content, source, searchString, searchParameters = null, searched = false }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [saveSearchModalState, setSaveSearchModalState] = useState({ label: "", autoCheck: true });

    return <Modal
        style={{ width: "50%", margin: "16px" }}
        dimmer={<Modal.Dimmer blurring style={{ backgroundColor: "#00000077" }} />}
        open={openSaveSearchModalState}
        centered={false}
        content={<div style={{ whiteSpace: "pre-wrap" }}>
            <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61", textAlign: "center" }}><h2>{header}</h2></Modal.Header>
            <br />
            <div style={{ padding: "0px 16px 0px 16px" }}>
                {content && <><h3>{content}</h3><br /></>}
                <br />
                <TextField style={{ width: "480px" }} className="inputField"
                    size="small" variant='outlined'
                    placeholder='Search label'
                    value={saveSearchModalState.label} /* onKeyUp={handleKeyUp} */
                    onChange={(e) => {
                        setSaveSearchModalState(prevState => { return { ...prevState, label: e.target.value } });
                    }}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="unselectable" style={{ cursor: "pointer" }}
                    onClick={() => { setSaveSearchModalState(prevState => { return { ...prevState, autoCheck: !prevState.autoCheck } }); }}>
                    <Checkbox style={{ padding: "0px 0px 4px 0px" }}
                        checked={saveSearchModalState.autoCheck} size="small"
                        color="primary" />Autocheck this search
                </span>
                <br />
                <br />
                <div style={{ width: "100%", textAlign: "center" }}>
                    <Button className="formButton" color={saveSearchModalState.buttonColorSave || 'green'}
                        style={{ padding: "6px", width: "150px" }}
                        content={saveSearchModalState.buttonTextSave || "Save"}
                        onClick={async () => {
                            let response = await saveSearch(apiToken, source, searchString, searchParameters, saveSearchModalState.label, saveSearchModalState.autoCheck, searched);
                            if (response.success && response.savedSearch) {
                                //HAVE TOAST APPEAR saying that search has been successfully saved
                                dispatch(savedSearchAdded(response.savedSearch));
                            }
                            setSaveSearchModalState({ label: "", autoCheck: true });
                            setOpenSaveSearchModalState(false);
                        }}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button className="formButton" color={saveSearchModalState.buttonColorCancel || 'red'}
                        style={{ padding: "6px", width: "150px" }}
                        content={saveSearchModalState.buttonTextCancel || "Cancel"}
                        onClick={() => {
                            setSaveSearchModalState({ label: "", autoCheck: true });
                            setOpenSaveSearchModalState(false);
                        }}
                    />
                </div>
                <br />
            </div>
        </div>}
    />
}

export default SaveSearchModal;